// extracted by mini-css-extract-plugin
module.exports = {"container":"_3G-OUYPrQGwQeyKeCNX3-a","externalId":"_1DTHOcVMC0J3djoZq30mLx"};